import React from 'react';

import './ranking-badge-style.scss';
import Typography from '@src/componentsNew/Typography/Typography';

interface IProps {
  rank: number;
}

const RankingBadge = ({ rank }: IProps) => {
  const isHighRank = rank <= 3;

  return (
    <div className={`ranking-badge ${isHighRank ? 'high' : ''}`}>
      <Typography variant="subtitle1" component="span" style={{ color: '#ffffff' }}>
        {rank}
      </Typography>
    </div>
  );
};

export default RankingBadge;
